import React, { useState, useEffect } from 'react';
import { http } from '../lib/http';
import { useLocation, useNavigate } from 'react-router-dom';
import './ResetPasswordPage.css';

const ResetPasswordPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Extract token from URL
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const t = query.get('token');
    if (!t) {
      setError('Invalid reset link');
    } else {
      setToken(t);
    }
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStatus('');

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    
    if (password.length > 64) {
      setError("Password cannot exceed 64 characters.");
      return;
    }
    
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);
    try {
      const data = await http.post('/api/auth/reset-password', { token, password });
      setStatus(data.message || 'Password reset successful.');
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
    <div className="auth-header">
      <div className="brand" onClick={() => navigate("/")}>
      <img src="/images/customroam-logo.png" alt="Logo" className="logo-img" />
      <span className="brand-text">CUSTOM ROAM</span>
     </div>
      <div className="back-home" onClick={() => navigate('/')}>
       Back to Home
     </div>
      </div>
    <div className="reset-password-container">
      <h2>Reset Password</h2>
      <form onSubmit={handleSubmit} className="reset-password-form">
      <input
  type="password"
  placeholder="New Password "
  value={password}
  required
  maxLength={64}
  onChange={(e) => setPassword(e.target.value)}
/>
<input
  type="password"
  placeholder="Confirm Password"
  value={confirmPassword}
  required
  maxLength={64}
  onChange={(e) => setConfirmPassword(e.target.value)}
/>
        <button type="submit" disabled={loading}>
          {loading ? 'Resetting...' : 'Reset Password'}
        </button>
      </form>

      {status && <p className="reset-success">{status}</p>}
      {error && <p className="reset-error">{error}</p>}
    </div>
    </div>
  );
};

export default ResetPasswordPage;
